import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Table,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import nxtIcn from "./assets/next-button.png";
import preIcn from "./assets/previous-button.png";
import playIcn from "./assets/play-button.png";
import unmteIcn from "./assets/unmute-icon.png";
import vwAllIcn from "./assets/view-all-button.png";
import homBtn from "./assets/button-home-filled-outline.png";
import lkIcn from "./assets/link-icon.png";
import lkIcnBlk from "./assets/link-icon-blk.png";
import moreBtn from "./assets/More-button-no-outline1.png";
import viewPlaylistIcon from "./assets/view-playlist-icon.png";
import videojs from "video.js";
import "videojs-playlist";
import "videojs-contrib-ads";
import "videojs-ima";
import "video.js/dist/video-js.css";
import "videojs-ima/dist/videojs.ima.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import {
  getSingleVideo,
  getPlaylist,
  getFeaturedList,
  getWebCategories,
  getFeaturedPlaylistVideos,
  getAllPlaylist,
} from "./service/featured";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import duration from "dayjs/plugin/duration";
import customParseFormat from "dayjs/plugin/customParseFormat";
import useVideoAnalytics from "./hooks/useVideoAnalytics";
import { copyToClipboard, getVideoMimeType, logSkipVideo } from "./helpers/globals";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./components/AuthProvider";
import ProfilePopover from "./components/ProfilePopover";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PartyPassPromotionModal from "./components/PartyPassPromotionModal";
import { initiatePartyPassPurchase } from "./utils/partyPass";
import { getPlaylistUrl } from "./utils/urlHelpers";
import VideoOverlayMenu from "./components/VideoOverlayMenu";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);
dayjs.extend(customParseFormat);

// const REFRESH_PAGE_DURATION = 22 * 60 * 1000;

const App = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [videos, setVideos] = useState([]);
  const [curTitle, setCurTitle] = useState("");
  const [curArtist, setcurArtist] = useState("");
  const [playlistVideos, setPlaylist] = useState("");
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState(null);
  const [isVideoFnd, setIsVideoFnd] = useState(true);
  const [modal, setModal] = useState(false);
  const [copiedTitle, setCopiedTitle] = useState("");
  const [featuredVideos, setFeaturedVideos] = useState([]);
  const [currentFeaturedVideo, setCurrentFeaturedVideo] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [header, setHeader] = useState("");
  const [videoUUID, setVideoUUID] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [heightDiv, setHeightDiv] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [currentPlaylist, setCurrentPlaylist] = useState(null);
  const [nextPlaylist, setNextPlaylist] = useState(null);
  const [showMaxSkipWarning, setShowMaxSkipWarning] = useState(false);
  const [homeCategory, setHomeCategory] = useState(null);
  const [playlistSearchTerm, setPlaylistSearchTerm] = useState("");
  const [showArtworkModal, setShowArtworkModal] = useState(false);
  const [showSkipOverlay, setShowSkipOverlay] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [browsingPlaylist, setBrowsingPlaylist] = useState(null);
  const [showBrowsingModal, setShowBrowsingModal] = useState(false);
  const [browsingPlaylistSearchTerm, setBrowsingPlaylistSearchTerm] = useState("");
  const [videoProgress, setVideoProgress] = useState(0);
  const overlayTimerRef = useRef(null);
  const mouseMoveTimerRef = useRef(null);

  const analytics = useVideoAnalytics();

  const { isAccessAllowed, preventGuestAccess, hasPartyPass, needsEmojiPicker } = useAuth();

  useEffect(() => {
    if (!currentPlaylist) {
      const playlistTime = dayjs().format("HH:00:00");

      getFeaturedPlaylistVideos(playlistTime)
        .then((response) => {
          const { data } = response.data;
          setCurrentPlaylist({
            time: playlistTime,
            playlist: {
              ...data,
              videos: data.videos.sort((a, b) => a.order - b.order),
            },
          });
        })
        .catch((error) => {
          console.error("Error while fetching the playlist:", error);
          setCurrentPlaylist(null);
        });
    }
  }, []);

  useEffect(() => {
    let nextPlaylistInterval;
    if (currentPlaylist) {
      nextPlaylistInterval = setInterval(() => {
        const playlistTime = dayjs().add(2, "minutes").format("HH:00:00");
        if (currentPlaylist?.time !== playlistTime) {
          clearInterval(nextPlaylistInterval);
          getFeaturedPlaylistVideos(playlistTime).then((response) => {
            const { data } = response.data;
            console.log('here');
            if (currentPlaylist?.playlist?.id !== data.id) {
              setNextPlaylist({
                time: playlistTime,
                playlist: {
                  ...data,
                  videos: data.videos.sort((a, b) => a.order - b.order),
                },
              });
            }
          }).catch((error) => console.error("Error while fetching the next playlist:", error));
        }
      }, 50);
    }

    return () => clearInterval(nextPlaylistInterval);
  }, [currentPlaylist]);

  useEffect(() => {
    let playlistSwapInterval;
    if (currentPlaylist && nextPlaylist) {
      playlistSwapInterval = setInterval(() => {
        const playlistTime = dayjs().format("HH:00:00");
        if (nextPlaylist?.time === playlistTime) {
          clearInterval(playlistSwapInterval);
          // player.current?.dispose?.();
          setNextPlaylist(null);
          setCurrentPlaylist(nextPlaylist);
        }
      }, 50);
    }

    return () => clearInterval(playlistSwapInterval);
  }, [currentPlaylist, nextPlaylist]);

  useEffect(() => {
    try {
      if (currentPlaylist && videoRef.current) {
        const playlistVideos = currentPlaylist.playlist.videos;

        const urls = playlistVideos.map((video) => {
          return {
            sources: [
              { src: video.video_url, type: getVideoMimeType(video.video_url) },
            ],
            poster: video.thumbnail_url,
            meta: {
              id: video.id,
            }
          };
        });

        if (player.current) {
          player.current.playlist(urls);

          player.current.on("play", () => {
            // Only set playing if actually playing (not blocked by browser)
            if (!player.current.paused()) {
              setIsVideoPlaying(true);
            }
            let curInd = player.current.playlist.currentItem();
            const playingVideo = playlistVideos[curInd];
            analytics.start(playingVideo.id);
            setCurTitle(playingVideo.title);
            setcurArtist(playingVideo.artist);
            setVideoUUID(playingVideo.video_id);
            setCurrentPlayingVideo(playingVideo);
          });

          handleChangeVideo(playlistVideos[0].id, true);
        } else {
          const videoMeta = playlistVideos[0];
          setCurTitle(videoMeta.title);
          setcurArtist(videoMeta.artist);
          setVideoUUID(videoMeta.video_id);
          setThumbnail(videoMeta.thumbnail_url);

          // Start
          const imaOptions = {
            adTagUrl:
              "https://pubads.g.doubleclick.net/gampad/ads?iu=/22978710279/mi_casa_su_casa&description_url=[placeholder]&tfcd=0&npa=0&sz=640x480&ciu_szs=300x600&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&impl=s&correlator=",
          };

          const videoOp = {
            controls: false,
            autoplay: false,
          };

          player.current = videojs(videoRef.current, videoOp, function () {
            if (this) {
              this.ima(imaOptions);
              this.playlist(urls);
              this.playlist.autoadvance(0);
              const Button = videojs.getComponent("Button");
              const previousBtn = new Button(this, {});
              previousBtn.controlText("Previous");
              previousBtn.addClass("vjs-visible-text");

              const previousBtnDom = previousBtn.el();
              previousBtnDom.id = 'previous-btn';
              previousBtnDom.innerHTML = `<img id='previous-btn-img' src=${preIcn} width="25%" />`;
              previousBtnDom.onclick = function (e) {
                preventGuestAccess();
                if (!player.current.el().classList.contains('vjs-waiting')) {
                  // player.current.playlist?.previous?.();
                  const previousIndex = player.current.playlist.previousIndex();
                  const previousVideo = player.current.playlist?.()?.[previousIndex];
                  handleChangeVideo(previousVideo?.meta?.id);
                }
              };
              this.getChild("ControlBar").addChild(previousBtn, {}, 1);

              const nextBtn = new Button(this, {});
              nextBtn.controlText("Next");
              nextBtn.addClass("vjs-visible-text");

              const nextBtnDom = nextBtn.el();
              nextBtnDom.id = 'next-btn';
              nextBtnDom.innerHTML = `<img id='next-btn-img' src=${nxtIcn} width="25%" />`;
              nextBtnDom.onclick = function (e) {
                preventGuestAccess();
                if (!player.current.el().classList.contains('vjs-waiting')) {
                  // player.current.playlist?.next?.();
                  const nextIndex = player.current.playlist.nextIndex();
                  const nextVideo = player.current.playlist?.()?.[nextIndex];
                  handleChangeVideo(nextVideo?.meta?.id);
                }
              };
              this.getChild("ControlBar").addChild(nextBtn, {}, 2);

              this.on("play", () => {
                preventGuestAccess();
                // Only set playing if actually playing (not blocked by browser)
                if (!this.paused()) {
                  setIsVideoPlaying(true);
                  setShowSkipOverlay(false);
                }
                let curInd = player.current.playlist.currentItem();
                const playingVideo = playlistVideos[curInd];
                analytics.start(playingVideo.id);
                setCurTitle(playingVideo.title);
                setcurArtist(playingVideo.artist);
                setVideoUUID(playingVideo.video_id);
                setCurrentPlayingVideo(playingVideo);
              });

              this.on("ended", () => {
                setIsVideoPlaying(false);
                setShowSkipOverlay(false);
                analytics.record();
                this.ima.requestAds();
              });

              this.on("pause", function () {
                setIsVideoPlaying(false);
                if (window.screen.width > 800) {
                  setShowSkipOverlay(true);
                }
                analytics.pause();
              });

              this.on("timeupdate", () => {
                const currentTime = this.currentTime();
                const duration = this.duration();
                if (duration > 0) {
                  setVideoProgress((currentTime / duration) * 100);
                }
              });

              this.playlist.repeat(true);

              this.on("touchstart", (e) => {
                if (e.target.classList.contains("vjs-playing")) {
                  // this.bigPlayButton.show();
                  analytics.pause();
                  this.pause();
                } else if (e.target.id === 'next-btn' || e.target.id === 'next-btn-img') {
                  document.getElementById('next-btn')?.click?.();
                } else if (e.target.id === 'previous-btn' || e.target.id === 'previous-btn-img') {
                  document.getElementById('previous-btn')?.click?.();
                }
              });
            }
          });
        }

        // return () => player.current?.dispose();
      }
    } catch (error) {
      console.error("while initialize", error);
    }

    // return () => {
    //   player.current?.dispose?.();
    // }
  }, [currentPlaylist, isAccessAllowed, preventGuestAccess]);

  // Fullscreen change handler
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      setIsFullscreen(isCurrentlyFullscreen);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  // Global mouse move handler for fullscreen mode
  useEffect(() => {
    if (isFullscreen) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('click', handleVideoTap);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('click', handleVideoTap);
      };
    }
  }, [isFullscreen]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.location.reload();
  //   }, REFRESH_PAGE_DURATION);
  // }, []);

  const toggle = () => setModal(!modal);

  const changeTitle = (title) => {
    setModal(!modal);
    setCopiedTitle(title);
  };

  // Video skip overlay handlers
  const handleVideoMouseEnter = () => {
    if (window.screen.width > 800 && !isFullscreen) {
      setShowSkipOverlay(true);
    }
  };

  const handleVideoMouseLeave = () => {
    if (window.screen.width > 800 && isVideoPlaying && !isFullscreen) {
      setShowSkipOverlay(false);
    }
  };

  const handleMouseMove = () => {
    if (isFullscreen) {
      setShowSkipOverlay(true);
      // Clear existing timer
      if (mouseMoveTimerRef.current) {
        clearTimeout(mouseMoveTimerRef.current);
      }
      // Auto-hide after 2 seconds of no mouse movement
      mouseMoveTimerRef.current = setTimeout(() => {
        if (isFullscreen) {
          setShowSkipOverlay(false);
        }
      }, 2000);
    }
  };

  const handleVideoTap = (e) => {
    // Only show overlay if clicking on video element, not controls
    if (window.screen.width <= 800 &&
      (e.target.tagName === 'VIDEO' || e.target.classList.contains('video-skip-overlay'))) {
      setShowSkipOverlay(true);
      // Auto-hide after 2 seconds on mobile
      if (overlayTimerRef.current) {
        clearTimeout(overlayTimerRef.current);
      }
      overlayTimerRef.current = setTimeout(() => {
        setShowSkipOverlay(false);
      }, 2000);
    }
  };

  const handleSkipToNext = (e) => {
    e.stopPropagation();
    if (currentPlaylist && player.current) {
      const nextIndex = player.current.playlist.nextIndex();
      const nextVideo = player.current.playlist?.()?.[nextIndex];
      if (nextVideo?.meta?.id) {
        setShowSkipOverlay(false);
        handleChangeVideo(nextVideo.meta.id);
      }
    }
  };

  const handlePausePlay = (e) => {
    e.stopPropagation();
    if (player.current) {
      if (player.current.paused()) {
        player.current.play();
      } else {
        player.current.pause();
      }
    }
  };

  const handleFullscreen = (e) => {
    e.stopPropagation();
    if (player.current) {
      if (player.current.isFullscreen()) {
        player.current.exitFullscreen();
      } else {
        player.current.requestFullscreen();
      }
    }
  };

  const handlePlaylistClick = (playlistId) => {
    // Fetch playlist details and show modal
    getPlaylist(playlistId)
      .then((response) => {
        const playlistData = response.data.data;
        const sortedVideos = playlistData.videos.sort((a, b) => a.order - b.order);
        setBrowsingPlaylist({
          ...playlistData,
          videos: sortedVideos
        });
        setShowBrowsingModal(true);
      })
      .catch((error) => {
        console.error("Error fetching playlist:", error);
      });
  };

  const player = useRef(null);

  const toHHMMSS = (duration) => {
    let mm = parseInt(duration / 60);
    duration = duration % 60;
    let ss = parseInt(duration);
    if (mm < 10) {
      mm = `0${mm}`;
    }
    if (ss < 10) {
      ss = `0${ss}`;
    }
    return `${mm}:${ss}`;
  };

  const handleChangeVideo = (id, skipLog = false) => {
    if (currentPlaylist && player.current) {
      const index = currentPlaylist.playlist.videos.findIndex((video) => {
        return video.id === id;
      });

      const selectedVideo = currentPlaylist.playlist.videos[index];


      if (skipLog ||
        currentPlaylist.playlist.videos[
          player.current.playlist.currentItem()
        ]?.id === id ||
        logSkipVideo(id, 3, hasPartyPass)
      ) {
        player.current.pause();
        analytics.record();
        player.current.playlist.currentItem(index);
        player.current.ima.requestAds();
        player.current.play();
      } else {
        setShowMaxSkipWarning(true);
      }
    }
  };

  const changeVideo = (id, e) => {
    setFeaturedVideos([]);

    const records = playlistVideos;
    for (let i = 0; i < records.length; i++) {
      records[i].is_playing = false;
    }
    setPlaylist([...records]);
    const urls = [];
    records.forEach((record) => {
      urls.push({
        sources: [
          { src: record.video_url, type: getVideoMimeType(record.video_url) },
        ],
        poster: record.thumbnail_url
      });
    });

    player.current.playlist(urls);
    player.current.playlist.autoadvance(0);
    player.current.on("play", () => {
      let curInd = player.current.playlist.currentItem();
      // analytics.start(records[curInd].id);
      setCurTitle(records[curInd].title);
      setcurArtist(records[curInd].artist);
      setVideoUUID(records[curInd].video_id);
      for (let i = 0; i < records.length; i++) {
        records[i].is_playing = false;
      }
      records[curInd].is_playing = true;
      setPlaylist([...records]);
    });
    player.current.on("touchstart", (e) => {
      if (e.target.classList.contains("vjs-playing")) {
        // this.bigPlayButton.show();
        // analytics.pause();
        player.current.pause();
      } else {
        player.current.play();
      }
    });


    const index = records.findIndex((video) => {
      return video.id === id;
    });
    // analytics.record();
    player.current.play();
    player.current.playlist.currentItem(index);
    for (let i = 0; i < records.length; i++) {
      records[i].is_playing = false;
    }
    records[index].is_playing = true;
    setVideos(records);
  };

  const unmuteVideo = (e) => {
    player.current.muted(false);
    e.target.style = "visibility: hidden;";
  };

  let IsNoVideo = ({ children }) => {
    return !isVideoFnd ? children : <></>;
  };

  useEffect(() => {
    let featureVideoInterval = null;
    if (featuredVideos.length) {
      featureVideoInterval = setInterval(() => {
        const currentStreamingFeaturedVideo = featuredVideos.find(
          (featuredVideo) => {
            if (!featuredVideo.streaming_time) {
              return true;
            }

            const streamingStartTime = dayjs(featuredVideo.streaming_time);
            const streamingEndTime = streamingStartTime.add(
              featuredVideo.video?.duration || 0,
              "seconds"
            );
            return (
              dayjs().isSameOrAfter(streamingStartTime) &&
              dayjs().isSameOrBefore(streamingEndTime)
            );
          }
        );

        if (currentFeaturedVideo?.id !== currentStreamingFeaturedVideo?.id) {
          setCurrentFeaturedVideo(currentStreamingFeaturedVideo || null);
        }
      }, 1000);
    }

    return () => clearInterval(featureVideoInterval);
  }, [featuredVideos, currentFeaturedVideo]);

  function skipToUserTimeOfVideo(streamingTime, videoMeta, playerObj) {
    // analytics.record();
    // analytics.start(videoMeta.id);
    if (streamingTime && videoMeta.duration) {
      const currentStreamingSeconds = dayjs().diff(
        dayjs(currentFeaturedVideo.streaming_time),
        "s"
      );
      if (currentStreamingSeconds <= videoMeta.duration) {
        playerObj?.currentTime(currentStreamingSeconds);
      }
    }
  }

  useEffect(() => {
    try {
      if (currentFeaturedVideo?.video && videoRef.current) {
        const videoMeta = currentFeaturedVideo?.video;
        setCurTitle(videoMeta.title);
        setcurArtist(videoMeta.artist);
        setVideoUUID(videoMeta.video_id);
        setThumbnail(videoMeta.thumbnail_url);

        // Start
        const imaOptions = {
          adTagUrl:
            "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/22978710279/mi_casa_su_casa&ciu_szs=300x250&env=vp&impl=s&gdfp_req=1&output=vast&unviewed_position_start=1&url=[referrer_url]&description_url=[description_url]&correlator=[timestamp]",
          // disableCustomPlaybackForIOS10Plus: true,
        };

        const urls = [
          {
            sources: [
              { src: videoMeta.video_url, type: getVideoMimeType(videoMeta.video_url) },
            ],
            poster: videoMeta.thumbnail_url
          },
        ];

        const videoOp = {
          controls: false,
        };

        // analytics.record();
        if (player.current?.src) {
          player.current.on("play", () => {
            skipToUserTimeOfVideo(
              currentFeaturedVideo.streaming_time,
              videoMeta,
              player.current
            );
          });
          // player.on('pause', () => {
          //   player.posterImage.show(); 
          // });
          player.current.src(urls[0].sources);
          player.current.on("ads-manager", function (response) {
            const adsManager = response.adsManager;
            if (
              adsManager &&
              window.google?.ima?.AdEvent?.Type?.ALL_ADS_COMPLETED
            ) {
              adsManager.addEventListener(
                window.google?.ima.AdEvent.Type.ALL_ADS_COMPLETED,
                () => {
                  skipToUserTimeOfVideo(
                    currentFeaturedVideo.streaming_time,
                    videoMeta,
                    player.current
                  );
                }
              );
            }
          });
        } else {
          player.current = videojs(
            videoRef.current,
            videoOp,
            function (...rest) {
              if (this) {
                this.ima(imaOptions);
                this.playlist(urls);
                this.playlist.autoadvance(0);

                this.on("play", () => {
                  skipToUserTimeOfVideo(
                    currentFeaturedVideo.streaming_time,
                    videoMeta,
                    this
                  );
                });

                this.on("ads-manager", function (response) {
                  const adsManager = response.adsManager;
                  if (
                    adsManager &&
                    window.google?.ima?.AdEvent?.Type?.ALL_ADS_COMPLETED
                  ) {
                    adsManager.addEventListener(
                      window.google?.ima.AdEvent.Type.ALL_ADS_COMPLETED,
                      () => {
                        skipToUserTimeOfVideo(
                          currentFeaturedVideo.streaming_time,
                          videoMeta,
                          player.current
                        );
                      }
                    );
                  }
                });

                this.on("pause", function () {
                  if (
                    !videoMeta.duration &&
                    this.currentTime() < videoMeta.duration
                  ) {
                    this.play();
                  } else {
                    // analytics.pause();
                  }
                });
              }
            }
          );
        }
      }
    } catch (error) {
      console.error("while autoplay", error);
    }
  }, [currentFeaturedVideo, videoRef.current]);

  useEffect(() => {
    // getFeaturedList()
    //   .then((response) => {
    //     const retrievedFeaturedVideos = response.data?.data;
    //     setFeaturedVideos(
    //       retrievedFeaturedVideos?.length ? retrievedFeaturedVideos : []
    //     );
    //     if(response.data.web_headers?.length) {
    //       setHeader(response.data.web_headers[0].HomePageHeaderText);
    //     }
    //     else {
    //       console.log("warning: empty response.data.web_headers", response.data.web_headers);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error while fetching the featured videos", error);
    //     setFeaturedVideos([]);
    //   });

    // getPlaylist(115)
    //   .then((response) => {
    //     const retrievedPlaylistVideos = response.data?.data.videos;
    //     retrievedPlaylistVideos?.sort((a, b) =>
    //       a.order > b.order ? 1 : b.order > a.order ? -1 : 0
    //     );
    //     setPlaylist(
    //       retrievedPlaylistVideos?.length ? retrievedPlaylistVideos : []
    //     );
    //   })
    //   .catch((error) => {
    //     console.error("Error while fetching the playlist videos", error);
    //     setPlaylist([]);
    //   });

    // getWebCategories()
    //   .then((response) => {
    //     const retrievedCategories = response.data?.data;
    //     if (retrievedCategories?.length) {
    //       setActiveCategory(retrievedCategories[0]);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error while fetching the category playlists", error);
    //     setActiveCategory(null);
    //   });

    getAllPlaylist()
      .then((response) => {
        const categories = response.data?.data?.categories;
        if (categories?.length) {
          const homeCategoryData = categories.find(category => category.id === 2);
          if (homeCategoryData) {
            setHomeCategory(homeCategoryData);
          }
        }
      })
      .catch((error) => {
        console.error("Error while fetching categories:", error);
        setHomeCategory(null);
      });

    const handleScroll = () => {
      setIsSticky(window.scrollY > 15);
    };

    window.addEventListener('scroll', handleScroll);

    if (window.screen.width > 800) {
      setHeightDiv(`${window.screen.height}px`);
    } else {
      setHeightDiv("auto")
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Spacebar pause/play handler
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.code === 'Space' && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        handlePausePlay(e);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div style={{ backgroundColor: "black", paddingBottom: "40px" }}>
      <div style={{ width: "100%" }}>
        <Header />
        <IsNoVideo>
          <div
            style={{ color: "white", margin: "4px auto", textAlign: "center" }}
          >
            <h2>
              Dang it, something went wrong. Please go to{" "}
              <Link to="/home">VIBE-STREAM.TV/home</Link>
            </h2>
          </div>
        </IsNoVideo>
      </div>
      {window.screen.width > 800 ? (
        <div style={{
          width: "85%",
          maxWidth: "1400px",
          color: "white",
          margin: "2px auto",
        }}>
          {/* <Link to={`/video/${videoUUID}`}> */}
          <h4 className="font-semibold">{curTitle}</h4>
          {/* </Link> */}
          <h6>{curArtist}</h6>
        </div>
      ) : (
        <></>
      )}
      <div className="video-con">
        <div className="player-con">
          {(window.screen.width < 800) ? (

            <div style={{
              color: "white",
              margin: "2px auto",
            }}>
              {/* <Link to={`/video/${videoUUID}`}> */}
              <h4 className="font-semibold">{curTitle}</h4>
              {/* </Link> */}
              <h6>{curArtist}</h6>
            </div>
          ) : (
            <></>
          )}
          <div
            className={`v video-player-wrapper ${isSticky ? 'vjs-fixed-box' : ''}`}
            onMouseEnter={handleVideoMouseEnter}
            onMouseLeave={handleVideoMouseLeave}
            onMouseMove={handleMouseMove}
            onClick={handleVideoTap}
          >
            <video
              id='featured-player'
              ref={videoRef}
              className="video-js vjs-16-9 vjs-big-play-centered"
              playsInline
            />

            {/* Video Overlay Menu (Center Controls + Side Menu) */}
            <VideoOverlayMenu
              playerRef={player}
              videoId={currentPlayingVideo?.id}
              videoUUID={videoUUID}
              videoTitle={curTitle}
              videoArtist={curArtist}
              isPlaying={isVideoPlaying}
              isFullscreen={isFullscreen}
              onPlayPause={handlePausePlay}
              onFullscreen={handleFullscreen}
              onSkip={handleSkipToNext}
              showPlayPause={true}
              showFullscreen={true}
              showSkip={true}
              showBookmark={true}
              showCopyLink={true}
              showThumbsdown={true}
              visible={showSkipOverlay || !isVideoPlaying}
              isMobile={window.screen.width <= 800}
            />

            {/* Progress Bar */}
            <div className="video-progress-bar">
              <div
                className="video-progress-fill"
                style={{ width: `${videoProgress}%` }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Now Playing Title */}
      <div className="playlist-carousel-container">
        <div className="playlist-title-row">
          <h3 className="playlist-title">
            Now Playing{currentPlaylist?.playlist?.name ? `: ${currentPlaylist.playlist.name}` : ''}
          </h3>
        </div>
      </div>

      {/* Now Playing Playlist Artwork */}
      {currentPlaylist?.playlist?.image_url && (
        <div className="now-playing-artwork-container">
          <div
            className="now-playing-artwork-card"
            onClick={() => {
              setShowArtworkModal(true);
            }}
          >
            <img
              src={currentPlaylist.playlist.image_url}
              alt={currentPlaylist.playlist.name}
            />
            <div className="now-playing-artwork-info">
              <h6 className="font-semibold">{currentPlaylist.playlist.name}</h6>
            </div>
          </div>
        </div>
      )}

      {/* Home Category Playlists */}
      {homeCategory && (
        <div className="home-category-container">
          <h3 className="home-category-title">{homeCategory.name}</h3>
          <div className="home-category-carousel">
            {homeCategory.playlists?.length > 0 ? (
              homeCategory.playlists.map((playlist) => (
                <div
                  key={playlist.id}
                  className="home-category-item"
                  onClick={() => handlePlaylistClick(playlist.id)}
                >
                  <img src={playlist.image_url} alt={playlist.name} />
                  <div className="home-category-item-info">
                    <h6 className="font-semibold">{playlist.name}</h6>
                  </div>
                </div>
              ))
            ) : (
              <div className="playlist-loading">
                <Spinner color="warning">Loading....</Spinner>
              </div>
            )}
          </div>
        </div>
      )}

      {/* <div className="img-con">
        <a href="https://app.gogopix.co/gogopixtv">
          <img
            className="imgBtn"
            style={{ marginTop: "45px" }}
            src={stoIcns}
            width="30%"
            alt="get the app logo"
          />
        </a>
      </div> */}
      {/* View All Button */}
      <div className="img-con">
        <Link to="/allplaylists">
          <img
            className="imgBtn"
            style={{ marginTop: "45px" }}
            src={vwAllIcn}
            width="20%"
            alt="view all"
          />
        </Link>
      </div>

      <Footer />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Video URL copied</ModalHeader>
        <ModalBody>
          The video url titled "{copiedTitle}" has been copied to the clipboard.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
      <PartyPassPromotionModal
        isOpen={showMaxSkipWarning}
        toggle={() => setShowMaxSkipWarning(false)}
        onUnlockClick={initiatePartyPassPurchase}
      />

      {/* Playlist Menu Popup */}
      <Modal
        isOpen={showArtworkModal}
        toggle={() => setShowArtworkModal(false)}
        className="playlist-menu-popup"
        size="lg"
      >
        <ModalHeader toggle={() => setShowArtworkModal(false)}>
          {currentPlaylist?.playlist?.name || 'Playlist'}
        </ModalHeader>
        <ModalBody className="playlist-menu-popup-body">
          {/* Playlist Artwork */}
          {currentPlaylist?.playlist?.image_url && (
            <div className="playlist-menu-artwork">
              <img
                src={currentPlaylist.playlist.image_url}
                alt={currentPlaylist.playlist.name}
                className="playlist-menu-artwork-image"
              />
            </div>
          )}

          {/* Search Input */}
          <div className="playlist-menu-search">
            <input
              type="text"
              className="playlist-menu-search-input"
              placeholder="Search videos by artist or title..."
              value={playlistSearchTerm}
              onChange={(e) => setPlaylistSearchTerm(e.target.value)}
            />
          </div>

          {/* Vertical Video List */}
          <div className="playlist-menu-videos">
            {currentPlaylist?.playlist?.videos?.length > 0 ? (
              currentPlaylist?.playlist?.videos
                .filter((record) => {
                  if (!playlistSearchTerm) return true;
                  const searchLower = playlistSearchTerm.toLowerCase();
                  return (
                    record.title.toLowerCase().includes(searchLower) ||
                    record.artist.toLowerCase().includes(searchLower)
                  );
                })
                .map((record) => (
                  <div
                    key={record.id}
                    className={`playlist-menu-video-item ${record.id === currentPlayingVideo?.id ? 'playing' : ''}`}
                    onClick={() => {
                      handleChangeVideo(record.id);
                      setShowArtworkModal(false);
                      setPlaylistSearchTerm("");
                    }}
                  >
                    <img src={record.thumbnail_url} alt={record.title} />
                    <div className="playlist-menu-video-info">
                      <h6 className="font-semibold">{record.title}</h6>
                      <p>{record.artist}</p>
                      {record.id === currentPlayingVideo?.id && (
                        <span className="playing-badge">Now Playing</span>
                      )}
                    </div>
                  </div>
                ))
            ) : (
              <div className="playlist-loading">
                <Spinner color="warning">Loading....</Spinner>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>

      {/* Featured Playlist Browsing Modal */}
      <Modal
        isOpen={showBrowsingModal}
        toggle={() => setShowBrowsingModal(false)}
        className="playlist-menu-popup"
        size="lg"
      >
        <ModalHeader toggle={() => setShowBrowsingModal(false)}>
          {browsingPlaylist?.name || 'Playlist'}
        </ModalHeader>
        <ModalBody className="playlist-menu-popup-body">
          {/* Playlist Artwork */}
          {browsingPlaylist?.image_url && (
            <div className="playlist-menu-artwork">
              <img
                src={browsingPlaylist.image_url}
                alt={browsingPlaylist.name}
                className="playlist-menu-artwork-image"
              />
            </div>
          )}

          {/* Search Input */}
          <div className="playlist-menu-search">
            <input
              type="text"
              className="playlist-menu-search-input"
              placeholder="Search videos by artist or title..."
              value={browsingPlaylistSearchTerm}
              onChange={(e) => setBrowsingPlaylistSearchTerm(e.target.value)}
            />
          </div>

          {/* Vertical Video List */}
          <div className="playlist-menu-videos">
            {browsingPlaylist?.videos?.length > 0 ? (
              browsingPlaylist.videos
                .filter((record) => {
                  if (!browsingPlaylistSearchTerm) return true;
                  const searchLower = browsingPlaylistSearchTerm.toLowerCase();
                  return (
                    record.title.toLowerCase().includes(searchLower) ||
                    record.artist.toLowerCase().includes(searchLower)
                  );
                })
                .map((record) => (
                  <div
                    key={record.id}
                    className="playlist-menu-video-item"
                    onClick={() => {
                      // Navigate to playlist page with selected video
                      navigate(getPlaylistUrl(browsingPlaylist, { video: record.order, autoplay: 1 }));
                    }}
                  >
                    <img src={record.thumbnail_url} alt={record.title} />
                    <div className="playlist-menu-video-info">
                      <h6 className="font-semibold">{record.title}</h6>
                      <p>{record.artist}</p>
                    </div>
                  </div>
                ))
            ) : (
              <div className="playlist-loading">
                <Spinner color="warning">Loading....</Spinner>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default App;
